import { FORM_ERROR_MSG } from '../../../../types/types';
import useAuth from '../../../../hooks/auth-hooks';
import { CUSTOMER_FORM } from '../form-customer-types';
import { showToast } from '../../../toasts';
import { checkForSelectValue } from '../../form-helpers';

import { INewCustomer } from '../../../../models/customer.interface';
import { awsPostNewCustomer } from '../../../../routes/post-new-customer';

/**
 * Posts data to the AWS api route to add new customer.
 * 
 * @returns void
 */
const AddCustomer = () => {
  const {
    customerCreateForm,
    customerPartner,
    customerSubmit,
    customerName,
    customerAccountNumber,
    customerGallonLimit,
    customerStatus,
    customerFileType,
  } = CUSTOMER_FORM;

  const validateForm = () => {
    customerCreateForm.classList.add('was-validated');

    checkForSelectValue(customerPartner, 'Partner', 'partner');

    return customerCreateForm.checkValidity() &&
           customerPartner.getAttribute('data-value') != null;
  };

  const handleSumbit = async (event: Event) => {
    event.preventDefault();
    event.stopPropagation();

    if (validateForm()) {
      customerCreateForm.classList.remove('was-validated');
      customerCreateForm.classList.remove('form-control:valid');
      customerSubmit.classList.add('aafp_button-loading');
      FORM_ERROR_MSG.innerHTML = '';

      const { userId } = useAuth()!;

      const awsJsonData = {
        adminId: userId,
        partner: Number(customerPartner.getAttribute('data-value')),
        customerName: customerName.value,
        accountNumber: customerAccountNumber.value,
        gallonLimit: customerGallonLimit.valueAsNumber,
        status: Number(customerStatus.value),
        fileType: customerFileType.value,
        exportTo: 'FTP'  
      }

      const { statusCode } = await awsPostNewCustomer(awsJsonData);
    
      if ( statusCode === 200 ) {
        showToast('aafp_toast', `${customerName.value} has been added`);
        setTimeout(() => {
          location.href = '/customers/';
        }, 1500);
      }
    }
  }

  customerCreateForm.addEventListener('submit', handleSumbit);
}

export default AddCustomer;